import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: {}, error: null };

const searchCartoonSlice = createSlice({
  name: 'searchCartoon',
  initialState,
  reducers: {
    searchCartoonHandler(state, action) {
      if (action.payload.error) {
        state.error = action.payload.error;
        state.data = {};
      } else {
        state.data = action.payload.data;
        state.error = null;
      }
    },
    clearSearchCartoons(state) {
      state.data = {};
      state.error = null;
    }
  },
});
export const searchCartoonAction = searchCartoonSlice.actions;
export default searchCartoonSlice;
